import ArticleCard from "@/components/feature/ArticleCard";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { articles } from "@/mocks/articles";

export default function LatestSection() {
  const latest = articles.slice(0, 6);

  return (
    <section id="latest" className="border-t border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="最新盘点"
            title="持续更新的盘点文章"
            desc="假期结束后仍在补充，围绕热度未退的话题继续做背景整理与后续进展说明。"
            action={{ label: "进入盘点列表", href: "/topics" }}
          />
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {latest.map((article, index) => (
            <Reveal key={article.id} delay={index * 50} className="h-full">
              <ArticleCard article={article} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}